<template>
  <div class="page-sign d-block st py-0">
      <div class="row g-0">
          <div class="col-md-7 col-lg-5 col-xl-4 col-wrapper">
              <div class="card card-sign">
                <div class="card-header">
                    <div class="text-center">
                        <img src="assets/images/logo1.png" style="width: 120px; margin-bottom: -10px;" alt="" />
                    </div>
                    <div class="text-center">
                        <a href="#" class="text-center header-logo mb-3 mt-0">CLIC</a>
                    </div>
                    <h3 class="card-title">Reset Password</h3>
                    <p class="card-text"></p>
                </div>
                <div class="card-body">
                    <div class="row g-2">
                        <div class="mb-12">
                            <label class="form-label">Email</label>
                            <input type="text" class="form-control" placeholder="Email" :class="{ 'is-invalid': errors.email }" v-model="user.email" ref="email" readonly />
                            <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                        </div>
                        <div class="mb-12">
                            <label class="form-label">OTP <span class="text-danger"> *</span></label>
                            <input type="text" tabindex=1 class="form-control" placeholder="Enter your OTP" :class="{'is-invalid':errors.otp}" v-model="user.otp" ref="otp" />
                            <span v-if="errors.otp" class="invalid-feedback">{{ errors.otp[0] }}</span>
                        </div>
                        <div class="col-sm-12">
                            <label class="form-label">New Password <span class="text-danger"> *</span></label>
                            <input type="password" tabindex=2 placeholder="New Password" class="form-control" :class="{'is-invalid': errors.new_password}" v-model="user.new_password" />
                            <span v-if="errors.new_password" class="invalid-feedback">{{ errors.new_password[0] }}</span>
                        </div>
                        <div class="col-sm-12">
                            <label class="form-label">Confirm Password <span class="text-danger"> *</span></label>
                            <input
                                type="password"
                                placeholder="Confirm Password"
                                class="form-control"
                                :class="{'is-invalid': errors.confirm_password}"
                                v-model="user.confirm_password"
                                tabindex=3
                            />
                            <span v-if="errors.confirm_password" class="invalid-feedback">{{ errors.confirm_password[0] }}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-end">
                        <div class="row">
                            <div class="col-md-6">
                                <router-link to="/" type="button" class="btn btn-sm btn-danger me-2"><i class="ri-close-line icon_hgt"></i>DISCARD</router-link>
                            </div>
                            <div class="col-md-6">    
                                <button  type="submit" tabindex=4 class="btn btn-sm btn-primary" @click="updatePassword()"><i class="ri-save-line icon_hgt"></i>SUBMIT</button>
                            </div>
                        </div>
                </div>
              </div>
          </div>
          <div class="col d-none d-lg-block"><img src="assets/images/bg5.jpg" class="auth-img" alt="" /></div>
      </div>
  </div>
</template>
<script>
    export default {
    name: "Login",
    data() {
        return {
            user: {
                email:'',
                otp: '',
                new_password: '',
                confirm_password:''
            },
            errors: [],
        };
    },
    beforeRouteEnter(to, from, next){
        next((vm)=>{
            vm.user.email = vm.$store.getters.email;
        })
    },
    mounted() {
        this.$refs.otp.focus();
    },
    methods: {
        updatePassword() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "updatePassword", data: vm.user })
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("success", "Password is successfully updated");
                    vm.$router.push('/');
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        
    },
};
</script>
<style>
  /* .st { */
  /* background-image: linear-gradient(to right, #053aed 40%, #323335 100%)!important; */
  /* background-image: linear-gradient(to right, #323335 40%, #053aed 100%)!important; */
  /* background-image: linear-gradient(to right, #323335 40%, #323335 100%)!important; */
  /* background-image: linear-gradient(to right, #053aed 10%, #323335 100%)!important; */
  /* } */

  .auth-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    mix-blend-mode: luminosity;
    opacity: .8!important;
}
.page-sign.d-block {
    background-image: linear-gradient(to right, #9ba9d8 40%, #5b7ce7 100%);
}
</style>
